import { render } from "./SimpleLoginModal.vue?vue&type=template&id=2bd4136a&scoped=true&ts=true"
import script from "./SimpleLoginModal.vue?vue&type=script&lang=ts"
export * from "./SimpleLoginModal.vue?vue&type=script&lang=ts"

import "./SimpleLoginModal.vue?vue&type=style&index=0&id=2bd4136a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd4136a"]])

export default __exports__